import { render } from "./AssessmentModal.vue?vue&type=template&id=3fe2c46d&scoped=true"
import script from "./AssessmentModal.vue?vue&type=script&lang=js"
export * from "./AssessmentModal.vue?vue&type=script&lang=js"

import "./AssessmentModal.vue?vue&type=style&index=0&id=3fe2c46d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe2c46d"]])

export default __exports__